










import { Component, Prop, Vue } from 'vue-property-decorator';
import { CommentView } from '../../comments/store/models';
import CommentListItem from './CommentListItem.vue';

@Component({
  components: {
    CommentListItem,
  },
})
export default class CommentList extends Vue {

  @Prop() private comments!: CommentView[];

  private handleEditComment(comment: CommentView): void {
    this.$emit('editComment', comment);
  }

}
